/*
Notes:
- this uses the Google Tag Manager's dataLayer
- GTM script is in public/index.html
- the window.dataLayer object is injected by the GTM script
*/
import Config from "../config";

function gtag() {
  window.dataLayer.push(arguments);
}
const conversion = (id, cost) => {
  if(window.dataLayer) {
    window.dataLayer.push({
      'event': 'shop-purchase',
      'purchase': {
        'id': id,
        'amount': String(cost),
        'currency': Config.currency
      }
    })

    // for GA4 -->
    

    // https://developers.google.com/tag-manager/ecommerce-ga4#measure_purchases
    window.dataLayer.push({ ecommerce: null, purchase:null });  // Clear the previous ecommerce object.
    window.dataLayer.push({
      event: "purchase",
      ecommerce: {
        transaction_id: id,
        value: cost,
        currency: Config.currency,
        items: []
      }
    });

    // https://developers.google.com/analytics/devguides/collection/ga4/reference/events#purchase

    /*
    gtag("event", "purchase", {
      currency: Config.currency,
      transaction_id: id,
      value: cost,
      items: [],
    });
    */
    
  }
  else {
    // TODO hopefully this never really happens, maybe use Sentry.io here?
    console.warn('GMT dataLayer NOT present')
  }
}

export default {
  conversion
}